import { FC, ReactNode } from 'react'
import { Inline } from '@shared/layout/Inline'
import WhiteLightning from '@assets/icons/whiteLightning.svg'
import BlueLightning from '@assets/icons/blueLightning.svg'
import { Week, Day, WeekStatus } from '../types'
import { WeekDescription } from './description'

export const WeekLeftSide: FC<{ type: WeekStatus; isLast: boolean }> = ({ type, isLast }) => {
	return (
		<div className={'flex w-[25px] flex-col items-center'}>
			{type === 'finished' && (
				<>
					<div
						className={
							'w-[25px] h-[25px] flex items-center justify-center bg-[#DCF831] rounded-full'
						}>
						<img src={BlueLightning} alt='Эта неделя завершена' />
					</div>
					<div className={'w-[3px] h-[118px] mt-1 bg-[#DCF831] rounded-full'}></div>
				</>
			)}
			{type === 'notFinished' && (
				<>
					<div
						className={
							'w-[25px] h-[25px] flex items-center justify-center bg-[#DCF831] rounded-full'
						}>
						<img src={BlueLightning} alt='Эта неделя завершена' />
					</div>
					{!isLast && (
						<div className={'w-[3px] h-[118px] mt-1 bg-[#DADADA] rounded-full'}></div>
					)}
				</>
			)}
			{type === 'notStarted' && (
				<>
					<div
						className={
							'w-[25px] h-[25px] flex items-center justify-center bg-[#DADADA] rounded-full'
						}>
						<img src={WhiteLightning} alt='Эта неделя еще не завершена' />
					</div>
					{!isLast && (
						<div className={'w-[3px] h-[118px] mt-1 bg-[#DADADA] rounded-full'}></div>
					)}
				</>
			)}
			{type === 'last' && (
				<>
					<div
						className={
							'w-[25px] h-[25px] flex items-center justify-center bg-[#DADADA] rounded-full'
						}>
						<img src={WhiteLightning} alt='Эта неделя еще не завершена' />
					</div>
				</>
			)}
		</div>
	)
}

export const WeekRightSide: FC<{ days: Day[]; status: WeekStatus; title: string }> = ({
	days,
	status,
	title,
}) => {
	return (
		<div className={'h-[147px]'}>
			<Inline className={'justify-between'}>
				<div className={'text-[18px] text-[#5664FF]'}>{title}</div>
				<div className={'text-[#7A7A7C] text-[18px]'}>
					<span className={'text-[#5664FF]'}>
						{days.filter(day => day.type === 'finished').length}
					</span>
					/7
				</div>
			</Inline>
			<WeekDescription days={days} status={status} />
		</div>
	)
}

export const StepperWeek = ({
	week,
	status,
	isLast,
}: {
	week: Week
	status: WeekStatus
	isLast: boolean
}) => {
	return (
		<div className={'flex w-full gap-x-2'}>
			<WeekLeftSide type={status} isLast={isLast} />
			<WeekRightSide days={week.days} status={status} title={week.title} />
		</div>
	)
}

export const VerticalStepper: FC<{
	weeks: Week[]
	weekPointer: number
}> = ({ weeks, weekPointer }) => {
	return (
		<div className={'ml-4 mr-11 w-full flex flex-col gap-y-1'}>
			{weeks.map((week, index) => {
				let status: 'finished' | 'notFinished' | 'notStarted' | 'last' = 'notStarted'
				if (weekPointer === index + 1) {
					status = 'notFinished'
				}
				if (weekPointer > index + 1) {
					status = 'finished'
				}
				if (weekPointer < index + 1) {
					status = 'notStarted'
				}

				return (
					<StepperWeek
						key={week.title}
						week={week}
						status={status}
						isLast={index === weeks.length - 1}
					/>
				)
			})}
		</div>
	)
}
